import React from 'react';
import { Snackbar as MuiSnackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useDispatch, useSelector } from 'react-redux';
import { AppActions } from '../../store/ducks/app';

interface SnackbarProps {
  autoHideDuration?: number;
}

const Snackbar: React.FC<SnackbarProps> = ({ 
  autoHideDuration = 4000 
}) => {
  const dispatch = useDispatch();

  const snackbar = useSelector((state: any) => state.app.snackbar);

  const handleClose = () => {
    dispatch(AppActions.hideSnackbar());
  };

  return (
    <MuiSnackbar
      open={snackbar.open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        severity={snackbar.severity}
        variant="filled"
        elevation={6}
      >
        {snackbar.message}
      </Alert>
    </MuiSnackbar>
  );
};

export default Snackbar; 